// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run yarn gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../schema/public';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCurrentClientLocationMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCurrentClientLocationMutation = { __typename?: 'Mutation', geolocationGetCurrentClientLocation?: { __typename?: 'GeolocationGetCurrentClientLocationMutationPayload', country?: { __typename?: 'GeolocationIpCountries', id: string, countryCode?: string, countryName?: string, cityName?: string }, errors?: Array<{ __typename?: 'GeolocationError', message?: string, code?: number, params?: Array<{ __typename?: 'GeolocationErrorParam', name?: string, value?: string }> }> } };


export const GetCurrentClientLocationMutationDocument = /*#__PURE__*/ gql`
    mutation GetCurrentClientLocationMutation {
  geolocationGetCurrentClientLocation(input: {}) {
    country {
      id
      countryCode
      countryName
      cityName
    }
    errors {
      message
      code
      params {
        name
        value
      }
    }
  }
}
    `;
export type GetCurrentClientLocationMutationMutationFn = Apollo.MutationFunction<GetCurrentClientLocationMutation, GetCurrentClientLocationMutationVariables>;
export function useGetCurrentClientLocationMutation(baseOptions?: Apollo.MutationHookOptions<GetCurrentClientLocationMutation, GetCurrentClientLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetCurrentClientLocationMutation, GetCurrentClientLocationMutationVariables>(GetCurrentClientLocationMutationDocument, options);
      }
export type GetCurrentClientLocationMutationHookResult = ReturnType<typeof useGetCurrentClientLocationMutation>;
export type GetCurrentClientLocationMutationMutationResult = Apollo.MutationResult<GetCurrentClientLocationMutation>;
export type GetCurrentClientLocationMutationMutationOptions = Apollo.BaseMutationOptions<GetCurrentClientLocationMutation, GetCurrentClientLocationMutationVariables>;